import { AppConfigSource } from '../src/common/config/app-config';

export const environment: AppConfigSource = {
  app: {
    name: 'Sequal Admin',
    environmentName: 'Development',
    production: false,
    domain: 'development.sequal.app',
    superAdminUsername: 'queenadmin',
  },
  captcha: {
    isCaptchaEnabled: true,
    turnstileSiteKey: '0x4AAAAAADNqDhayer0baz0R',
  },
  backend: {
    apiWebEndpoint: 'https://api-development.sequal.app',
  },
  messaging: {
    webSocketEndpoint: '/messaging',
  },
  registration: {
    isRegistrationAllowed: false,
    publicKey: `
    -----BEGIN PUBLIC KEY-----
    MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA3JxRgwfzq9P425+OKV9a
    UjzTvGd+Gaixug2F4WLlw+Nbfav9gmPrakdh77lO9BHljjNnFhnHzj5kCyO+OUCp
    YKAEUy5Bv9NF/9w+b2TIYJdGlkLm3mxLctV456hw6ty1Gd8VhbgMWJ3/aBTFX7eD
    1vakLMmdCfo+F7IDQaMo/KVOhcmZgijtoICp2kguSW1QnOjc0e83KnTgO4/6D6AS
    AiH9FeKYKKUqRxqUDpVEftEv0iUutpMPMcvgWr4n2CT6y8DH+Tc8W8qnfVrzX3Hx
    +t2GtXPSnkOqqILokXKu1YJxgesCGRZyLlyYbj0NDaQMbzWEmCHesIP2oIACoUAV
    Pm1l2F7S4xz8DkWjd9duuiRXD4Gvw1eSCY589V8dAfuPUEkEov3QDZP8ohxTjxdx
    slUbPPa72f7IQbR4FhzFJZ3wFNSh5C8yndVJgpzO7K8AGQJkPLFOfzTS6CA30tnY
    BdtPcXVxMFt/xp7bSsDYjJ5NelIw7ZOs4V0cidL6obbfOz95XNx6IUSG0oHwStCX
    oov2pnbYk+m+EXZgPtwGV/HbktlFEICpwX3UwvGavlXoZ2xBFWi1Hei6qvBQJXpU
    VQn2tQa3CrmM4Lm+saGAY7hO4gJtz97vsVGErxBhSXUo8cvwQ0F5zM7ocPp3RCwR
    5UeWVuYvkcKPCD1K3+tfnSECAwEAAQ==
    -----END PUBLIC KEY-----
    `,
  },
  table: {
    pageSize: 30,
  },
  links: {
    apiUrl: 'https://api-development.sequal.app',
    appUrl: 'https://app-development.sequal.app',
    adminUrl: 'https://admin-development.sequal.app',
    landingUrl: 'https://development.sequal.app',
  },
  business: {
    // IANA zone the business operates in. Every date/time the admin renders,
    // every "today" it resolves and every picked date it sends to the api is
    // interpreted in this zone. Must match the api's BUSINESS_TIMEZONE.
    timezone: 'Australia/Brisbane',
  },
  finance: {
    // 7 = July (AU financial year). Drives the This/Last-financial-year
    // presets in the shared finance date-range picker.
    accountingYearStartMonth: 7,
  },
};
